import React from 'react';

import { UserPage, CouponPage, UserGroupPage } from 'pages';
import { USER_MENU_URL } from 'data/menu';

const USER_GROUP_URL = USER_MENU_URL['회원 그룹 관리'];

const userApp = [
  {
    path: USER_MENU_URL.회원목록,
    element: <UserPage.List />,
  },
  {
    path: `${USER_MENU_URL.회원목록}/:id`,
    element: <UserPage.Detail />,
  },
  {
    path: USER_GROUP_URL,
    element: <UserGroupPage.List />,
  },
  {
    path: `${USER_GROUP_URL}/register`,
    element: <UserGroupPage.Register />,
  },
  {
    path: `${USER_GROUP_URL}/:id`,
    element: <UserGroupPage.Detail />,
  },
  {
    path: USER_MENU_URL.쿠폰목록,
    element: <CouponPage.List />,
  },
];

export { userApp };
